// src/stone/icons/PhoneChat.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PhoneChat = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10 2a1 1 0 0 0-1 1v8.382L11.764 10H21a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM7.879.879A3 3 0 0 1 10 0h11a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-8.764L7 14.618V3A3 3 0 0 1 7.879.879M7.5 20.444a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" }),
      /* @__PURE__ */ jsx("path", { d: "M.752 2.93C1.25 2.357 1.958 2 2.733 2H6v2H2.733c-.144 0-.317.065-.47.24C2.107 4.42 2 4.693 2 5v16c0 .308.107.58.263.76.153.175.326.24.47.24h9.534c.144 0 .317-.065.47-.24.156-.18.263-.452.263-.76v-8h2v8c0 .753-.258 1.5-.752 2.07-.498.574-1.207.93-1.981.93H2.733c-.775 0-1.483-.356-1.981-.93A3.17 3.17 0 0 1 0 21V5c0-.753.258-1.5.752-2.07" })
    ]
  }
);
var PhoneChat_default = PhoneChat;

export {
  PhoneChat_default
};
